import React, { useMemo } from "react";

import "./styles.scss";
import { useAccountSettings } from "@/utils";
import { WebSettings } from "@/interfaces";
import { Leaderboard } from "@/services/bedrock";
import { LeaderboardTable, LeaderboardModal, BulkLeaderboardExportDialog } from "@/components";
import { Button } from "@/components/ui";
import { Download } from "lucide-react";

const LeaderboardsFC = () => {
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [modalBoard, setModalBoard] = React.useState<Leaderboard>();
  const [showExportDialog, setShowExportDialog] = React.useState<boolean>(false);

  const { hasAccountSetting } = useAccountSettings();
  const hasScriptLibrary = useMemo(() => {
    return hasAccountSetting(WebSettings.ACCESS_SCRIPT_LIBRARY);
  }, [hasAccountSetting]);

  const leaderboardColumns: Leaderboard[][] = useMemo(() => {
    const leftBoards: Leaderboard[] = [
      { title: "Top Prompts", entityType: "prompt" },
      { title: "Top Campaigns", entityType: "campaign" },
      { title: "Top Posts", entityType: "post" },
    ];

    if (hasScriptLibrary) {
      leftBoards.push({ title: "Top Scripts", entityType: "video_script" });
    }

    leftBoards.push({ title: "Top Video Pages", entityType: "content_page" });

    const rightBoards: Leaderboard[] = [
      { title: "Top Accounts", entityType: "social_identity", startTimeKey: "all" },
      { title: "Top Players", entityType: "player" },
      { title: "Top Regions", entityType: "region" },
      { title: "Top Branches", entityType: "branch" },
    ];

    return [leftBoards, rightBoards];
  }, [hasScriptLibrary]);

  return (
    <div className="coachLeaderboards">
      <div className={"flex flex-row justify-between items-center mb-8"}>
        <div className="text-2xl font-bold text-foreground">Leaderboards</div>
        <Button onClick={() => setShowExportDialog(true)}>
          <Download /> Export
        </Button>
      </div>

      <div className={"flex flex-row gap-6 w-full"}>
        {leaderboardColumns.map((column, index) => {
          return (
            <div className={"flex flex-col flex-1 gap-6"} key={`leaderboard-column-${index}`}>
              {column.map(board => {
                return (
                  <LeaderboardTable
                    key={`leaderboard-${board.entityType}`}
                    title={board.title}
                    entityType={board.entityType}
                    onViewAll={(startTimeKey, metric) => {
                      setModalBoard({
                        ...board,
                        startTimeKey,
                        metric,
                      });
                      setShowModal(true);
                    }}
                  />
                );
              })}
            </div>
          );
        })}
      </div>

      <LeaderboardModal open={showModal} onClose={() => setShowModal(false)} board={modalBoard} />
      {showExportDialog && <BulkLeaderboardExportDialog open={showExportDialog} onOpenChange={setShowExportDialog} />}
    </div>
  );
};

export const Leaderboards = LeaderboardsFC;
